<fe-header style="z-index: 10000"></fe-header>
<main>
    <fe-banner-landing-title
        [title]="'Programa de renta de autos para empresas'"
        [imageSrc]="'images/banner_empresas_header.jpg' | cdn"
        [subtitle]="'fe_enterprises_subtitle' | translate"
    ></fe-banner-landing-title>
    <section class="benefits-section">
        <div class="container">
            <div
                class="text-start text-md-center mb-5 d-flex flex-column flex-md-row lign-items-center justify-content-between"
            >
                <div class="">
                    <h2>{{ 'fe_enterprises_benefits_title' | translate }}</h2>
                    <p class="subtitle mb-0">
                        {{ 'fe_enterprises_benefits_subtitle' | translate }}
                    </p>
                </div>

                <div class="mt-4 mt-md-0">
                    <fe-button
                        class="d-none d-lmd-flex pt-4"
                        [href]="'/es/empresas'"
                        [fragment]="'sectionForm'"
                        [style]="'primary'"
                        >{{ 'fe_enterprises_button' | translate }}</fe-button
                    >
                </div>
            </div>

            <div class="row g-4">
                <!-- Columna izquierda -->
                <div class="col-md-6">
                    <div class="benefit-box h-100">
                        <ul>
                            <li>
                                <img
                                    [src]="
                                        'images/empresas_renta_flexible.svg'
                                            | cdn
                                    "
                                    alt="Renta flexible sin mínimos"
                                    class="img-fluid"
                                />{{
                                    'fe_enterprises_benefits_first' | translate
                                }}
                            </li>
                            <li>
                                <img
                                    [src]="'images/empresas_tarifas.svg' | cdn"
                                    alt="Renta flexible sin mínimos"
                                    class="img-fluid"
                                />{{
                                    'fe_enterprises_benefits_second' | translate
                                }}
                            </li>
                            <li>
                                <img
                                    [src]="
                                        'images/empresas_prioridad.svg' | cdn
                                    "
                                    alt="Renta flexible sin mínimos"
                                    class="img-fluid"
                                />{{
                                    'fe_enterprises_benefits_third' | translate
                                }}
                            </li>
                            <li>
                                <img
                                    [src]="
                                        'images/empresas_descuento.svg' | cdn
                                    "
                                    alt="Renta flexible sin mínimos"
                                    class="img-fluid"
                                />{{
                                    'fe_enterprises_benefits_fourth' | translate
                                }}
                            </li>
                            <li>
                                <img
                                    [src]="
                                        'images/empresas_reservaciones.svg'
                                            | cdn
                                    "
                                    alt="Renta flexible sin mínimos"
                                    class="img-fluid"
                                />{{
                                    'fe_enterprises_benefits_fifth' | translate
                                }}
                            </li>
                            <li>
                                <img
                                    [src]="
                                        'images/empresas_auto_sustituto.svg'
                                            | cdn
                                    "
                                    alt="Renta flexible sin mínimos"
                                    class="img-fluid"
                                />{{
                                    'fe_enterprises_benefits_sixth' | translate
                                }}
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Columna derecha -->
                <div class="col-md-6">
                    <div class="benefit-box h-100">
                        <ul>
                            <li>
                                <img
                                    [src]="
                                        'images/empresas_opciones_pago.svg'
                                            | cdn
                                    "
                                    alt="Renta flexible sin mínimos"
                                    class="img-fluid"
                                />{{
                                    'fe_enterprises_benefits_seventh'
                                        | translate
                                }}
                            </li>
                            <li>
                                <img
                                    [src]="'images/empresas_placas.svg' | cdn"
                                    alt="Renta flexible sin mínimos"
                                    class="img-fluid"
                                />{{
                                    'fe_enterprises_benefits_eighth' | translate
                                }}
                            </li>
                            <li>
                                <img
                                    [src]="
                                        'images/empresas_mantenimiento.svg'
                                            | cdn
                                    "
                                    alt="Renta flexible sin mínimos"
                                    class="img-fluid"
                                />{{
                                    'fe_enterprises_benefits_nine' | translate
                                }}
                            </li>
                            <li>
                                <img
                                    [src]="
                                        'images/empresas_tarifas_extranjero.svg'
                                            | cdn
                                    "
                                    alt="Renta flexible sin mínimos"
                                    class="img-fluid"
                                />{{
                                    'fe_enterprises_benefits_tenth' | translate
                                }}
                            </li>
                            <li>
                                <img
                                    [src]="
                                        'images/empresas_protecciones.svg' | cdn
                                    "
                                    alt="Renta flexible sin mínimos"
                                    class="img-fluid"
                                />{{
                                    'fe_enterprises_benefits_eleventh'
                                        | translate
                                }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="enterprises__register">
        <div class="enterprises__register__content container py-4">
            <div class="container-xl">
                <div class="row">
                    <div class="col-12">
                        <h2>
                            {{ 'fe_enterprises_register_title_2' | translate }}
                        </h2>
                        <hr />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lmd-4 d-flex">
                        <div class="bg-white p-4 flex-fill">
                            <h3>
                                {{
                                    'fe_enterprises_register_first_number'
                                        | translate
                                }}
                            </h3>
                            <h3>
                                {{
                                    'fe_enterprises_register_first_info_2'
                                        | translate
                                }}
                            </h3>
                            <p>
                                {{
                                    'fe_enterprises_register_first_description'
                                        | translate
                                }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-lmd-4 d-flex py-4 py-lmd-0">
                        <div class="bg-white p-4 flex-fill">
                            <h3>
                                {{
                                    'fe_enterprises_register_second_number'
                                        | translate
                                }}
                            </h3>
                            <h3>
                                {{
                                    'fe_enterprises_register_second_info'
                                        | translate
                                }}
                            </h3>
                            <p>
                                {{
                                    'fe_enterprises_register_second_description'
                                        | translate
                                }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-lmd-4 d-flex">
                        <div class="bg-white p-4 flex-fill">
                            <h3>
                                {{
                                    'fe_enterprises_register_third_number'
                                        | translate
                                }}
                            </h3>
                            <h3>
                                {{
                                    'fe_enterprises_register_third_info'
                                        | translate
                                }}
                            </h3>
                            <p>
                                {{
                                    'fe_enterprises_register_third_description'
                                        | translate
                                }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div
                        class="col-12 d-flex justify-content-center align-items-center"
                    >
                        <fe-button
                            class="d-none d-lmd-flex pt-4"
                            [href]="'/es/empresas'"
                            [fragment]="'sectionForm'"
                            [style]="'primary'"
                            >{{
                                'fe_enterprises_button' | translate
                            }}</fe-button
                        >
                        <a
                            [href]="'/es/empresas#sectionForm'"
                            class="btn__footer d-flex d-lmd-none justify-content-center mt-3"
                            >{{ 'fe_enterprises_button' | translate }}</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="rental-options">
        <div class="container">
            <h2>{{ 'fe_enterprises_rent_title' | translate }}</h2>

            <div class="row align-items-center g-4">
                <!-- Columna izquierda (tarjetas) -->
                <div class="col-lg-7">
                    <div class="row g-4">
                        <div class="col-6 option-card-wrapper">
                            <div class="option-card">
                                <img
                                    [src]="
                                        'images/empresas_renta_flexible.svg'
                                            | cdn
                                    "
                                    alt="Renta flexible sin mínimos"
                                    class="img-fluid"
                                />
                                <h5>
                                    {{
                                        'fe_enterprises_rent_title_card_1'
                                            | translate
                                    }}
                                </h5>
                                <a
                                    href="https://www.alamo.com.mx/es/empresas/renta-flexible"
                                    >{{
                                        'fe_enterprises_rent_cta' | translate
                                    }}
                                    <i class="bi bi-arrow-right"></i
                                ></a>
                            </div>
                        </div>

                        <div class="col-6 option-card-wrapper">
                            <div class="option-card">
                                <img
                                    [src]="
                                        'images/empresas_alamo_arrendamiento.svg'
                                            | cdn
                                    "
                                    alt="Renta flexible sin mínimos"
                                    class="img-fluid"
                                />
                                <h5>
                                    {{
                                        'fe_enterprises_rent_title_card_2'
                                            | translate
                                    }}
                                </h5>
                                <a
                                    href="https://www.alamo.com.mx/es/empresas/alamo-arrendamiento"
                                    >{{
                                        'fe_enterprises_rent_cta' | translate
                                    }}
                                    <i class="bi bi-arrow-right"></i
                                ></a>
                            </div>
                        </div>

                        <div class="col-6 option-card-wrapper">
                            <div class="option-card">
                                <img
                                    [src]="
                                        'images/empresas_tipos_autos.svg' | cdn
                                    "
                                    alt="Renta flexible sin mínimos"
                                    class="img-fluid"
                                />
                                <h5>
                                    {{
                                        'fe_enterprises_rent_title_card_3'
                                            | translate
                                    }}
                                </h5>
                                <a
                                    href="https://www.alamo.com.mx/es/empresas/alamo-tipos-autos"
                                    >{{
                                        'fe_enterprises_rent_cta' | translate
                                    }}
                                    <i class="bi bi-arrow-right"></i
                                ></a>
                            </div>
                        </div>

                        <div class="col-6 option-card-wrapper">
                            <div class="option-card">
                                <img
                                    [src]="
                                        'images/empresas_alamo_leasing.svg'
                                            | cdn
                                    "
                                    alt="Renta flexible sin mínimos"
                                    class="img-fluid"
                                />
                                <h5>
                                    {{
                                        'fe_enterprises_rent_title_card_4'
                                            | translate
                                    }}
                                </h5>
                                <a
                                    href="https://www.alamo.com.mx/es/empresas/alamo-leasing"
                                    >{{
                                        'fe_enterprises_rent_cta' | translate
                                    }}
                                    <i class="bi bi-arrow-right"></i
                                ></a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Columna derecha (imagen) -->
                <div class="col-lg-5 rental-image">
                    <img
                        [src]="'images/empresas_opciones_renta.png' | cdn"
                        alt="Renta flexible sin mínimos"
                        class="img-fluid"
                    />
                </div>
            </div>
        </div>
    </section>

    <section class="enterprises__strip">
        <div class="enterprises__strip__content container">
            <div class="container-xl">
                <div class="row align-items-stretch">
                    <div class="col-12 col-md-4 py-4">
                        <div class="d-flex flex-row align-items-start h-100">
                            <img
                                class="me-2 me-md-4 align-self-center"
                                [src]="'images/custom-service.svg' | cdn"
                                alt="Stretching hands icon"
                            />
                            <div class="d-flex flex-column">
                                <h3>
                                    {{
                                        'fe_enterprises_strip_title_1'
                                            | translate
                                    }}
                                </h3>
                                <p>
                                    {{
                                        'fe_enterprises_strip_paragraph_1'
                                            | translate
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 py-4">
                        <div class="d-flex flex-row align-items-start h-100">
                            <img
                                class="me-2 me-md-4 align-self-center"
                                [src]="'images/call-service.svg' | cdn"
                                alt="Stretching hands icon"
                            />
                            <div class="d-flex flex-column">
                                <h3>
                                    {{
                                        'fe_enterprises_strip_title_2'
                                            | translate
                                    }}
                                </h3>
                                <p>
                                    {{
                                        'fe_enterprises_strip_paragraph_2'
                                            | translate
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 py-4">
                        <div class="d-flex flex-row align-items-start h-100">
                            <img
                                class="me-2 me-md-4 align-self-center"
                                [src]="'images/empresas_ejecutivo.svg' | cdn"
                                alt="Stretching hands icon"
                            />
                            <div class="d-flex flex-column">
                                <h3>
                                    {{
                                        'fe_enterprises_strip_title_3'
                                            | translate
                                    }}
                                </h3>
                                <p>
                                    {{
                                        'fe_enterprises_strip_paragraph_3'
                                            | translate
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <fe-cars-cards></fe-cars-cards>
    <section class="enterprises__insurance">
        <div class="enterprises__insurance__content container py-4">
            <div
                class="d-flex flex-row justify-content-between align-items-end pb-4 pe-4"
            >
                <h2 class="m-0 pb-1">
                    {{ 'fe_enterprises_insurance_title' | translate }}
                </h2>
            </div>
            <div class="container-xl">
                <div class="row">
                    <div class="col-12 col-lmd-6 d-flex align-items-center">
                        <div class="row w-100">
                            <div class="col-lmd-4 d-none d-lmd-grid card__blue">
                                <div
                                    class="d-flex flex-column pt-4 align-items-center justify-content-center h-100"
                                >
                                    <p class="p__title m-0">
                                        {{
                                            'fe_enterprises_insurance_first_card_percent_number'
                                                | translate
                                        }}<span>{{
                                            'fe_enterprises_insurance_first_card_percent_symbol'
                                                | translate
                                        }}</span>
                                    </p>
                                    <p class="p__subtitle m-0">
                                        {{
                                            'fe_enterprises_insurance_first_card_percent_deducible'
                                                | translate
                                        }}
                                    </p>
                                </div>
                            </div>
                            <div
                                class="col-12 col-lmd-8 card__white bg-white p-3 px-3 px-lmd-4 h-100"
                            >
                                <div
                                    class="d-flex flex-column align-items-start justify-content-start"
                                >
                                    <h3 class="deducible d-lmd-none m-0 ps-1">
                                        {{
                                            'fe_enterprises_insurance_first_card_percent_join'
                                                | translate
                                        }}
                                    </h3>
                                    <h3 class="m-0 ps-1">
                                        {{
                                            'fe_enterprises_insurance_first_card_percent_insurance'
                                                | translate
                                        }}
                                    </h3>
                                    <ul class="m-0 ps-4">
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_first_card_percent_insurance_li_1'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_first_card_percent_insurance_li_2'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_first_card_percent_insurance_li_3'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_first_card_percent_insurance_li_4'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_first_card_percent_insurance_li_5'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_first_card_percent_insurance_li_6'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_first_card_percent_insurance_li_7'
                                                    | translate
                                            }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lmd-6 d-flex align-items-center">
                        <div class="row w-100 h-100">
                            <div
                                class="col-lmd-4 d-none d-lmd-grid card__green"
                            >
                                <div
                                    class="d-flex flex-column pt-4 align-items-center justify-content-center h-100"
                                >
                                    <p class="p__title m-0">
                                        {{
                                            'fe_enterprises_insurance_second_card_percent_number'
                                                | translate
                                        }}<span>{{
                                            'fe_enterprises_insurance_second_card_percent_symbol'
                                                | translate
                                        }}</span>
                                    </p>
                                    <p class="p__subtitle m-0">
                                        {{
                                            'fe_enterprises_insurance_second_card_percent_deducible'
                                                | translate
                                        }}
                                    </p>
                                    <p class="p__extra m-0">
                                        {{
                                            'fe_enterprises_insurance_second_card_percent_deducible_extra'
                                                | translate
                                        }}
                                    </p>
                                </div>
                            </div>
                            <div
                                class="col-12 col-lmd-8 card__white bg-white p-3 px-3 px-lmd-4 my-3 my-lmd-0 h-100"
                            >
                                <div
                                    class="d-flex flex-column align-items-start justify-content-start"
                                >
                                    <h3
                                        class="deducible d-flex d-lmd-none align-items-center m-0 ps-1"
                                    >
                                        {{
                                            'fe_enterprises_insurance_second_card_percent_join'
                                                | translate
                                        }}
                                        <p class="m-0 ms-2">
                                            {{
                                                'fe_enterprises_insurance_second_card_percent_join_extra'
                                                    | translate
                                            }}
                                        </p>
                                    </h3>
                                    <h3 class="m-0 ps-1">
                                        {{
                                            'fe_enterprises_insurance_second_card_percent_insurance'
                                                | translate
                                        }}
                                    </h3>
                                    <ul class="m-0 ps-4">
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_second_card_percent_insurance_li_1'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_second_card_percent_insurance_li_2'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_second_card_percent_insurance_li_3'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_second_card_percent_insurance_li_4'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_second_card_percent_insurance_li_5'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_second_card_percent_insurance_li_6'
                                                    | translate
                                            }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-12 d-none d-lmd-flex justify-content-center ps-0 pe-4 pt-4"
                    >
                        <fe-button
                            class="d-none d-lmd-flex pt-4"
                            [href]="'/es/empresas'"
                            [fragment]="'sectionForm'"
                            [style]="'primary'"
                            >{{
                                'fe_enterprises_button' | translate
                            }}</fe-button
                        >
                    </div>
                    <div class="col-12 d-flex d-lmd-none ps-0 pe-4 pt-4">
                        <a
                            [href]="'/es/empresas#sectionForm'"
                            class="btn__footer d-flex d-lmd-none justify-content-center"
                            >{{ 'fe_enterprises_button' | translate }}</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="renta-form py-5 enterprises" id="sectionForm">
        <div class="container">
            <div class="row align-items-center">
                <!-- Columna Izquierda: Formulario -->
                <div class="col-lg-8">
                    <h2 class="renta-form__title">
                        {{ 'fe_enterprises_form_title_1' | translate }}
                        <span>{{
                            'fe_enterprises_form_title_2' | translate
                        }}</span>
                    </h2>
                    <p class="renta-form__subtitle">
                        {{ 'fe_hbspt_form_subtitle' | translate }}
                    </p>

                    <fe-app-form-enterprises></fe-app-form-enterprises>
                </div>

                <!-- Columna Derecha: Imagen -->
                <div class="col-lg-4 text-center mt-4 mt-lg-0">
                    <img
                        [src]="'images/carro-ilustracion.svg' | cdn"
                        alt="Formulario ilustración"
                        class="img-fluid"
                    />
                </div>
            </div>
        </div>
    </section>

    <fe-blog-cards></fe-blog-cards>
</main>
<fe-footer></fe-footer>
